export enum NotificationType {
  SYSTEM = 'system',             // 系统
  ALERT = 'alert',               // 告警
  CHAT = 'chat',                 // 聊天,私信
  ANNOUNCEMENT = 'announcement',  // 公告
  FEEDBACK = 'feedback'          // 反馈
}

export enum NotificationStatus {
  UNREAD = 'unread',
  READ = 'read'
}

export enum NotificationMethod {
  web = 'web',
  sms = 'sms',
  email = 'email'
}

export enum NotificationSendStatus {
  SUCCESS = 'success',
  FAIL = 'fail',
  PENDING = 'pending'
}